import { useMiniappSdk } from 'components/miniapp-sdk-provider/miniapp-sdk.hook';
import { useEffect } from 'react';

export const useToggleSwipeGestures = () => {
  const client = useMiniappSdk();

  useEffect(() => {
    client?.swipe.disableBackSwipe();
    return () => client?.swipe.enableBackSwipe();
  }, [client]);
};
